// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic__comments{display:block}.topic__comments__new-count{padding:10px;margin-bottom:10px;background-color:#dd5454;border:1px solid #f16c6c;color:#fff;text-align:center;cursor:pointer}.topic__comments__message{padding:50px 0;text-align:center;font-size:21px;color:#c6c6c6;text-shadow:0 0 3px #262626}.topic__comments__message .glyphicons{font-size:80px;margin-bottom:5px}.topic__comments__page-spinner{margin-top:20px}", ""]);
// Exports
module.exports = exports;
